import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { ToastProvider } from 'react-toast-notifications';
import firebase from 'firebase/app';
import 'firebase/auth';
import { FirebaseAuthProvider } from '@react-firebase/auth';
import GlobalStyles from './assets/styles/GlobalStyles';
import Routers from './routers';
import { PaginationProvider } from './contexts/PaginationProvider';
import { UserProvider } from './contexts/UserProvider';
import { ModalQrCodeProvider } from './contexts/ModalQrCode';
import { MenuLoggedProvider } from './contexts/MenuLoggedProvider';
import { config } from './config/firebase';
import AuthAnonymous from './components/AuthAnonymous';
import SandboxBanner from './components/SandboxBanner';
import './i18nextConf';

ReactDOM.render(
  <Suspense fallback="...">
    <FirebaseAuthProvider {...config} firebase={firebase}>
      <ToastProvider placement="bottom-center">
        <ModalQrCodeProvider>
          <PaginationProvider>
            <UserProvider>
              <MenuLoggedProvider>
                <AuthAnonymous />
                <Routers />
                <SandboxBanner />
              </MenuLoggedProvider>
            </UserProvider>
          </PaginationProvider>
        </ModalQrCodeProvider>
      </ToastProvider>
    </FirebaseAuthProvider>
    <GlobalStyles />
  </Suspense>,
  document.getElementById('root'),
);
